<template>
  <div class="questions-screen-wrapper">

    <h5>
      List of challenges
    </h5>

    <div v-for="challenge in challengesList">
      <v-card>
        <v-card-title primary-title>
          <h6>{{ challenge.name }}</h6>
        </v-card-title>
        <v-card-text class="mb-3">

          <v-layout row wrap v-if="showGoToQuestion(challenge.status)">
            <v-flex sm4 xs6 class="card-text__item">
              Difficulty: {{ getDifficulty(challenge.difficulty) }}
            </v-flex>
            <v-flex sm4 xs6 class="card-text__item">
              <v-chip class="white--text" :class="'chip-' + challenge.status">
                {{ challenge.status }}
              </v-chip>
            </v-flex>
            <v-flex sm4 xs12 class="card-text__item">
              <v-btn
                @click="goToQuestion(challenge.challengeId)"
                flat :class="'goto-button-' + challenge.status"
              >
                Go to question
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-else>
            <v-flex sm4 xs4 class="card-text__item">
              Difficulty: {{ getDifficulty(challenge.difficulty) }}
            </v-flex>
            <v-flex sm4 xs4 class="card-text__item">
              <v-chip class="white--text" :class="'chip-' + challenge.status">
                {{ challenge.status }}
              </v-chip>
            </v-flex>
            <v-flex sm4 xs4 class="card-text__item">
              <div>
                {{ challenge.distanceToUserReadable }}
              </div>
            </v-flex>
          </v-layout>

        </v-card-text>
      </v-card>
    </div>

  </div>
</template>

<script>

  import {
    assign,
    cloneDeep,
    get,
    map,
    round,
  } from 'lodash'
  import * as sort from 'stable'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import { mapGetters } from 'vuex'
  import { challengeStatus } from '@/services/challengeStatus.enum'
  import { difficultyMap } from '../services/difficulty.enum'

  const getters = mapGetters([
    'challengesLocations',
    'userLocation',
  ])

  const sortHelper = {
    [challengeStatus.SOLVED]: 3,
    [challengeStatus.UNLOCKED]: 2,
    [challengeStatus.LOCKED]: 1,
  }

  export default {
    name: 'questions',
    data() {
      return {
        challengesList: [],
      }
    },
    computed: {
      ...getters,
    },
    mounted() {
      this.buildQuestionsList(this.challengesLocations)
    },
    watch: {
      challengesLocations: function (challengesLocations) {
        this.buildQuestionsList(challengesLocations)
      },
    },
    methods: {
      buildQuestionsList(challengesLocations) {
        if (challengesLocations) {
          const challenges = cloneDeep(challengesLocations)

          this.challengesList = sort(challenges, (c1, c2) => {
            return sortHelper[c1.status] < sortHelper[c2.status]
          })

          VueGoogleMaps.loaded
            .then(() => {
              const challengesWithDistances = this.getDistanceForLockedChallenges()
              this.challengesList = sort(challengesWithDistances, (c1, c2) => {
                if (c1.status === challengeStatus.LOCKED && c1.status === c2.status) {
                  return c1.distanceToUserRound > c2.distanceToUserRound
                }
                return sortHelper[c1.status] < sortHelper[c2.status]
              })
            })
        }
      },
      goToQuestion(challengeId) {
        this.$router.push({ name: 'Question', params: { id: challengeId } })
      },
      getDistanceForLockedChallenges() {

// eslint-disable-next-line no-undef
        const userLocationPoint = new google.maps.LatLng(this.userLocation.lat, this.userLocation.lng)
        return map(this.challengesList, challenge => {
          if (challenge.status === challengeStatus.LOCKED) {
// eslint-disable-next-line no-undef,no-undef
            const challengeLocation = new google.maps.LatLng(challenge.location.lat, challenge.location.lng)
// eslint-disable-next-line no-undef
            const sphericalMaps = get(google, 'maps.geometry.spherical')
            if (sphericalMaps) {
              const distanceToUserGoogle = sphericalMaps.computeDistanceBetween(userLocationPoint, challengeLocation)
              const distanceToUserRound = round(distanceToUserGoogle)
              const distanceToUserReadable = this.getReadableDistance(distanceToUserRound)
              return assign({}, challenge, {
                distanceToUserRound,
                distanceToUserReadable,
              })
            }
          }
          return challenge
        })
      },
      getReadableDistance(distanceToUser) {
        if (distanceToUser < 1000) {
          return round(distanceToUser, -1) + 'm'
        } else if (distanceToUser < 10000) {
          return round(distanceToUser / 1000, 1) + 'km'
        }
        return round(distanceToUser / 1000) + 'km'
      },
      showGoToQuestion(status) {
        return status === challengeStatus.SOLVED ||
          status === challengeStatus.UNLOCKED
      },
      getDifficulty(difficulty) {
        return difficultyMap[difficulty]
      },
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .goto-button-solved {
    color: green !important;
  }

  .goto-button-unlocked {
    color: darkcyan !important;
  }

  .chip-solved {
    background-color: #48CF64;
    color: #0E5446 !important;
  }

  .chip-unlocked {
    background-color: #4AC2D5;
    color: #0C2154 !important;
  }

  .chip-locked {
    background-color: #D7D7D7;
    color: #595959 !important;
  }

  .chip-failed {
    background-color: red;
    color: #595959 !important;
  }

  .questions-screen-wrapper {
    background-color: #fafafa;
  }

  .back-button-wrapper {
    text-align: left;

    .icon {
      font-size: 1.2rem;
      margin-right: 10px;
    }
  }

  h5 {
    margin-top: 20px;
  }

  .card {
    max-width: 500px;

    .card__title {
      padding-bottom: 0;

      @media screen and (max-width: 600px) {
        .h6 {
          font-size: 18px;
        }
      }

      h6 {
        text-align: left;
      }
    }

    .card__text {
      padding-top: 0;

      .row {
        align-items: center;
      }

      .btn {
        margin-bottom: 0;
      }
    }
  }

  .card {
    margin: auto;
  }

  @media screen and (max-width: 548px) {
    .card {
      margin: 24px;
    }
  }

  img {
    width: 80vw;
    max-width: 600px;
    margin: 20px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Questions.vue